<div class="mt-2">
  <div class="row my-2 px-3">
    <div class="col-12 text-start editToolbar">
      <dx-toolbar>
        <dxi-item location="before" widget="dxButton" locateInMenu="never">
          <div *dxTemplate>
            <div class="toolbar-label">
              <b> Agency Info</b>
            </div>
          </div>
        </dxi-item>

        <dxi-item location="after" locateInMenu="never">
          <div *dxTemplate>
            <dx-button
              [visible]="Entity.agentAgentInfoMga | hasPermission: EntityPermissionActivityKeys.write | async"
              [icon]="'edit'"
              [stylingMode]="'text'"
              [agMergeGuard]="agentSig()?.dbId"
              (agMergeGuardedClick)="showEditorModal()"
            ></dx-button>
          </div>
        </dxi-item>
      </dx-toolbar>
    </div>
  </div>

  <div *var="agentSig() as agent" class="row mt-2 px-3" [style.row-gap]="'8px'">
    <div class="col-2">
      <b>Agent ID:</b>
    </div>
    <div class="col-4">{{ agent?.p_agent_id | empty }}</div>

    <div class="col-2">
      <b>Agent Type:</b>
    </div>
    <div class="col-4">{{ agent?.agent_type | empty }}</div>

    <div class="col-2">
      <b> MGA: </b>
    </div>

    <div class="col-4">
      {{ agent?.p_mga_id | agency | async | empty }}
    </div>

    <div class="col-2">
      <b> Agency: </b>
    </div>

    <div class="col-4">{{ agent?.p_agency_id | agency | async | empty }}</div>

    <div class="col-2">
      <b> Is Team Lead? </b>
    </div>

    <div class="col-4">{{ agent?.is_manager | yesNo }}</div>

    <div class="col-2">
      <b> Agency Director: </b>
    </div>

    <div class="col-4">{{ agent?.is_credited | yesNo }}</div>

    <div class="col-2">
      <b> Is RMD: </b>
    </div>

    <div class="col-4">{{ agent?.is_rmd | yesNo }}</div>

    <div class="col-2">
      <b> Upline: </b>
    </div>

    <div class="col-4">{{ agent?.upline | empty }}</div>

    @if (isManagerFieldVisibleSig()) {
      <div class="col-2">
        <b> Team Lead </b>
      </div>

      <div class="col-4">
        {{ agent?.manager_id | mgaTeamLeadDescription | async | empty }}
      </div>
    }
  </div>
</div>

<ag-shr-agent-disposition-modal
  #agentDispositionModalRef
  [canEditMGA]="true"
  [isRMDVisible]="true"
  [canViewApproveDenyReason]="false"
  [canCreateApproveDenyReason]="false"
  [canEditApproveDenyReason]="false"
  [canDeleteApproveDenyReason]="false"
></ag-shr-agent-disposition-modal>
